"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _empty = _interopRequireDefault(require("../empty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Status = function Status(_ref) {
  var error = _ref.error,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? 'An error occurred.' : _ref$errorMessage,
      children = _ref.children,
      pending = _ref.pending,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 300 : _ref$height,
      testID = _ref.testID,
      empty = _ref.empty,
      emptyMessage = _ref.emptyMessage;
  return error ? /*#__PURE__*/_react.default.createElement(ErrorUI, {
    height: height,
    errorMessage: errorMessage,
    testID: testID
  }) : pending ? /*#__PURE__*/_react.default.createElement(PendingUI, {
    height: height,
    testID: testID
  }) : empty ? /*#__PURE__*/_react.default.createElement(_empty.default, emptyMessage) : children;
};

var ErrorUI = function ErrorUI(_ref2) {
  var height = _ref2.height,
      errorMessage = _ref2.errorMessage,
      testID = _ref2.testID;
  return /*#__PURE__*/_react.default.createElement(Wrap, {
    height: height,
    testID: testID
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "center"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: '44px'
    },
    className: "large-icon red material-icons block"
  }, "error"), /*#__PURE__*/_react.default.createElement("h4", null, "Error"), /*#__PURE__*/_react.default.createElement("p", null, errorMessage)));
};

var PendingUI = function PendingUI(_ref3) {
  var height = _ref3.height,
      testID = _ref3.testID;
  return /*#__PURE__*/_react.default.createElement(Wrap, {
    height: height,
    testID: testID
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner"
  }));
};

var Wrap = function Wrap(_ref4) {
  var height = _ref4.height,
      children = _ref4.children,
      testID = _ref4.testID;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: height + 'px'
    },
    "data-test-id": testID,
    className: "col-12 flex items-center justify-center"
  }, children);
};

Status.propTypes = {
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  pending: _propTypes.default.bool,
  height: _propTypes.default.number,
  testID: _propTypes.default.string,
  empty: _propTypes.default.bool,
  emptyMessage: _propTypes.default.shape({
    icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object]),
    title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object]),
    text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.object])
  })
};
PendingUI.propTypes = {
  height: _propTypes.default.number,
  testID: _propTypes.default.string
};
Wrap.propTypes = {
  height: _propTypes.default.number,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  testID: _propTypes.default.string
};
ErrorUI.propTypes = {
  errorMessage: _propTypes.default.string,
  height: _propTypes.default.number,
  testID: _propTypes.default.string
};
var _default = Status;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Status, "Status", "/Users/darcy/sites/cs-theme/src/components/status/index.js");
  reactHotLoader.register(ErrorUI, "ErrorUI", "/Users/darcy/sites/cs-theme/src/components/status/index.js");
  reactHotLoader.register(PendingUI, "PendingUI", "/Users/darcy/sites/cs-theme/src/components/status/index.js");
  reactHotLoader.register(Wrap, "Wrap", "/Users/darcy/sites/cs-theme/src/components/status/index.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/status/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();